import {
  Component,
  Inject,
  PLATFORM_ID,
  OnInit,
  ElementRef,
  ViewChild
} from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from '../../../../services/cart';
import { UrlSlugifyService } from '../../../../services/url-slugify';
import { Meta, Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import Swal from 'sweetalert2';
import { BundleService } from '../../../../services/bundles';
import { Swiper } from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';



@Component({
  selector: 'app-bundledetails',
  templateUrl: './bundledetails.component.html',
  styleUrl: './bundledetails.component.scss'
})
export class BundledetailsComponent implements OnInit {
  @ViewChild('bundleSwiper', { static: false }) bundleSwiperEl!: ElementRef;

  bundleSlides: string[] = [];
  swiper?: Swiper;
  contentReady = false;
  isAr = false;

  product: any; // bundle object

  quantity = 0;
  showShare = false;

  private isBrowser: boolean;

  constructor(
    private bundleService: BundleService,
    private meta: Meta,
    private title: Title,
    private route: ActivatedRoute,
    private cartService: CartService,
    private _slugify: UrlSlugifyService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  prepareSlides(): void {

    if (!this.product) return;

    let images: string[] = [];

    // صورة الباندل الأساسية
    if (this.product.image) {
      images.push(this.fixImage(this.product.image));
    }

    // صور المنتجات اللي جوه الباندل
    if (this.product.items?.length) {
      this.product.items.forEach((item: any) => {
        if (item.stock?.image) {
          images.push(this.fixImage(item.stock.image));
        }
      });
    }

    this.bundleSlides = images;
  }
  private initSwiper(): void {

    if (!this.isBrowser || !this.bundleSwiperEl) return;

    // لو فيه swiper قديم
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.bundleSwiperEl.nativeElement, {
      modules: [Navigation, Pagination, Autoplay],

      navigation: true,
      pagination: { clickable: true },

      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },

      loop: true,
      speed: 1200
    });
  }

  // ================= INIT =================
  ngOnInit(): void {

    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

    // Listen to route param changes
    this.route.params.subscribe(params => {
      const id = Number(params['id']);
      this.loadBundle(id);

      if (this.isBrowser) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }
  private loadBundle(id: number): void {

    this.contentReady = true;

    this.bundleService.getById(id).subscribe({
      next: (data: any) => {

        this.contentReady = false;
        this.product = data;

        // ✅ Build Slider Images
        this.prepareSlides();

        // ✅ Init Swiper بعد DOM
        setTimeout(() => this.initSwiper(), 0);

        // Quantity from cart
        if (this.isBrowser) {
          this.quantity =
            this.cartService.getBundleQuantity(this.product.id);
        }

        // SEO
        this.setSEO();
      },
      error: (err) => {
        console.error("Error fetching bundle:", err);
        this.contentReady = false;
      }
    });
  }
  fixImage(url: string): string {
    return `https://backendproduction.blueboxpet.com/storage/app/public/${url}`;
  }
  calcDis(newP: any, oldP: any): number | null {

    const off = Math.round(((parseInt(oldP) - parseInt(newP)) / oldP) * 100);
    return isNaN(off) ? null : off;
  }
  plus(bundle: any): void {
    if (!this.isBrowser) return;

    this.cartService.addBundleToCart(bundle);

    this.quantity =
      this.cartService.getBundleQuantity(bundle.id);
  }
  min(bundle: any): void {
    if (!this.isBrowser) return;

    const currentQty =
      this.cartService.getBundleQuantity(bundle.id);

    if (currentQty > 0) {
      this.cartService.removeBundleFromCart(bundle);

      this.quantity =
        this.cartService.getBundleQuantity(bundle.id);
    }
  }
  setSEO(): void {

    if (!this.product) return;

    const bundleName = this.isAr
      ? this.product.name_ar
      : this.product.name_en;

    const price = this.product.pricea;
    const image = this.fixImage(this.product.image);

    const slug = this._slugify.slugify(this.product.name_en);

    const url =
      `https://bboxmart.com/product/${slug}/${this.product.id}`;

    this.title.setTitle(`${bundleName} | Bundle Offer | Zazu Mart`);

    this.meta.updateTag({
      name: 'description',
      content: `${bundleName} bundle offer for only ${price} EGP. Limited deal from Zazu Mart.`
    });

    this.meta.updateTag({ property: 'og:type', content: 'product' });
    this.meta.updateTag({ property: 'og:title', content: bundleName });
    this.meta.updateTag({
      property: 'og:description',
      content: `Get this bundle for ${price} EGP with free gift.`
    });

    this.meta.updateTag({ property: 'og:image', content: image });
    this.meta.updateTag({ property: 'og:url', content: url });

    if (this.isBrowser) {
      this.setCanonical(url);
    }
  }

  private setCanonical(url: string): void {

    let link =
      document.querySelector("link[rel='canonical']") as HTMLLinkElement;

    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }

    link.setAttribute('href', url);
  }
  toggleShare(): void {
    this.showShare = !this.showShare;
  }

  buildShareUrl(): string {
    return `https://product.bboxmart.com/share/bundle/${this.product.id}`;
  }

  shareFacebook(): void {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.buildShareUrl())}`,
      '_blank'
    );
  }

  shareWhatsApp(): void {
    window.open(
      `https://wa.me/?text=${encodeURIComponent(this.buildShareUrl())}`,
      '_blank'
    );
  }

  shareTelegram(): void {
    window.open(
      `https://t.me/share/url?url=${encodeURIComponent(this.buildShareUrl())}`,
      '_blank'
    );
  }

  copyShareLink(): void {

    const url = this.buildShareUrl();

    navigator.clipboard.writeText(url).then(() => {
      Swal.fire({
        icon: 'success',
        title: this.isAr ? 'تم النسخ!' : 'Copied!',
        timer: 1200,
        showConfirmButton: false
      });
    });
  }

}
